<!-- =========================================================================================
    File Name: CompanyListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
      <vx-card title="Companies">
        <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

        <div class="vx-row no-gutter">
          <div class="vx-col w-full">
            <label for="foobar">{{ `${cyclopedia.companies.length} Companies` }}</label>
            <v-select id="foobar" multiple label="name" :value="selectedCompanies" :reduce="company => company.company_id" @input="companySelectionChanged" :options="unSelectedCompanies" />
          </div>
        </div>


      </vx-card>

</template>

<script>
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import {cyclopediaHelpers} from '@/models/helpers';
  import api from '@/http/api';

  export default {
    components: {
    },
    data() {
      return {
        loading: false,
        types: types,
        jsonHtml: jsonHtml,
        helpers: cyclopediaHelpers,
        selectedCompanyIds: [],
        allCompanies: [],
        companies: [],
      }
    },
    props: {
      cyclopedia: {
        type: types.Cyclopedia(),
        required: true,
        default: () => {
          return new types.Cyclopedia()
        }
      },
    },
    created() {
      this.fetchCompanies();
    },
    mounted() {
      // window.addEventListener("keyup", function(e) {
      //   if (e.key === 'Escape') {
      //   }
      // });
    },
    watch: {
      cyclopedia(oldVal, newVal) {
        if (newVal.id === oldVal.id) return;
        this.setUpWorkingData();
      },
      companies(oldVal, newVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.setUpWorkingData();
      },
    },
    computed: {
      selectedCompanies() {
        return this.allCompanies.filter((company) => {
          return this.selectedCompanyIds.indexOf(company.company_id) !== -1;
        });
      },
      unSelectedCompanies() {
        return this.allCompanies.filter((company) => {
          return this.selectedCompanyIds.indexOf(company.company_id) === -1;
        });
      },
    },
    methods: {
      async fetchCompanies() {
        this.loading = true;
        let companiesObj = await api.fetchAllCompanies();
        this.companies = companiesObj.companies;
        this.loading = false;
      },
      async companySelectionChanged(newSelectedCompanies) {
        if (newSelectedCompanies.length === this.selectedCompanyIds.length) return;
        const companyAdded = newSelectedCompanies.length > this.selectedCompanyIds.length;

        let success = false;
        if (companyAdded) {
          let addedCompanyId = newSelectedCompanies.filter(x => !this.selectedCompanyIds.includes(x))[0];
          console.log(`company ${addedCompanyId} added to ${this.cyclopedia.id}`);
          success = await api.addCompanyToCyclopedia(this.cyclopedia, addedCompanyId);
        } else {
          let removedCompanyId = this.selectedCompanyIds.filter(x => !newSelectedCompanies.includes(x))[0];
          console.log(`company ${removedCompanyId} removed from ${this.cyclopedia.id}`);
          success = await api.deleteCompanyFromCyclopedia(this.cyclopedia, removedCompanyId);
        }

        this.showNotification(success, companyAdded ? `Company${success ? '' : ' NOT'} added to ${this.cyclopedia.name}` : `Company${success ? '' : ' NOT'} removed from ${this.cyclopedia.name}`);

        this.selectedCompanyIds = newSelectedCompanies;

      },
      setUpWorkingData() {
        this.selectedCompanyIds = this.cyclopedia.companies.map((company) => company.company_id);
        this.allCompanies = JSON.parse(JSON.stringify(this.companies));
      },
      confirmDeleteGroup(cyclopedia) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'DELETE',
          title: `DELETE ${cyclopedia.name}`,
          text: `Are you sure you want to delete this cyclopedia?`,
          accept: () => {
            this.deleteGroup(cyclopedia);
          }
        })
      },
      async deleteGroup(cyclopedia) {
        const success = api.deleteCompanyCompanyGroup(cyclopedia);
        if (!success) {
          this.showNotification(false, 'error deleting cyclopedia');
          return;
        }

        this.showNotification(true, `Group "${cyclopedia.name}" Deleted`);

        this.$emit('cyclopediaDeleted', cyclopedia);

      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
  .fill-row-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
